export default __webpack_public_path__ + "static/media/calendar.f4373515.svg";